import { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isNullOrEmpty, showMessageToastCustom, translate } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Button } from '../../../../components/UI/ComponentsUI'
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import ContainerItemsAviexp from './ContainerItemsAviexp';
import ContainerItemsBop from './ContainerItemsBop';
import ContainerItemsLot from './ContainerItemsLot';
import { getVision } from '../../../../services/auth';
import { VISIONS } from '../../../../utils/constants';

const TransferContainer = (props) => {
    const [container1, setContainer1] = useState({});
    const [container2, setContainer2] = useState({});
    const [filter, setFilter] = useState({});

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const searchContainer = (container1) => {
        if (validateInputsRequired('getOrigem')) {
            if (filter.container1 === filter.container2) {
                return showMessageToastCustom(translate('warning', 'general'),
                    "Ação interditada: Container Origem não pode ser igual ao de destino!", 3000, 'mdi mdi-alert-circle-outline red-text');
            }

            filter.name = container1 ? filter.container1 : filter.container2;
            if (isNullOrEmpty(filter.name)) {
                return
            }

            props.getContainer(filter, (response) => {
                if (response) {
                    if (container1) {
                        if (!response.containerItem || response.containerItem.length === 0) {
                            setContainer1({});
                            setContainer2({});
                            return showMessageToastCustom(translate('warning', 'general'), "Ação interditada: Container Origem vazio!", 3000, 'mdi mdi-alert-circle-outline red-text');
                        }
                        setContainer1(response);
                    } else {
                        setContainer2(response)
                    }
                } else {
                    if (container1) {
                        setContainer1({})
                    }
                    else {
                        setContainer2({})
                    }
                    showMessageToastCustom(translate('warning', 'general'), "Container não encontrado", 3000, 'mdi mdi-alert-circle-outline red-text');
                }
            })
        }
    }

    const sendChange = () => {
        var data = [{
            containerId: container1.id,
            containerItems: container1.containerItem
        }, {
            containerId: container2.id,
            containerItems: container2.containerItem
        }]

        props.sendContainerChange(data, () => {
            setFilter({});
            setContainer1({});
            setContainer2({});
        })
    };

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('container:storage:menu.transfer-container') }} />

            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container">
                    {
                        (getVision() === VISIONS.PortoReal || getVision() === VISIONS.Palomar) ?
                            <ContainerItemsAviexp
                                searchContainer={searchContainer}
                                filter={filter}
                                setFilter={setFilter}
                                onChange={onChange}
                                container1={container1}
                                container2={container2}
                                setContainer2={setContainer2}
                                setContainer1={setContainer1} /> :
                            ((getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) ?
                                <ContainerItemsLot
                                    searchContainer={searchContainer}
                                    filter={filter}
                                    setFilter={setFilter}
                                    onChange={onChange}
                                    container1={container1}
                                    container2={container2}
                                    setContainer2={setContainer2}
                                    setContainer1={setContainer1} /> :
                                <ContainerItemsBop
                                    searchContainer={searchContainer}
                                    filter={filter}
                                    setFilter={setFilter}
                                    onChange={onChange}
                                    container1={container1}
                                    container2={container2}
                                    setContainer2={setContainer2}
                                    setContainer1={setContainer1} />)
                    }
                    {
                        container1.id > 0 && container2.id > 0 &&
                        <div className="row">
                            <Button full="true" onClick={() => sendChange()} text={'Confirmar Transferência'} />
                        </div>
                    }
                </div>
            </div>
        </div>

    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getContainer: (filter, callback) => {
            dispatch(ContainerService.getContainerChange(filter, callback));
        },
        sendContainerChange: (data, callback) => {
            dispatch(ContainerService.sendContainerChange(data, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TransferContainer));